import React from "react";
import { Helmet } from "react-helmet";
import { NestedContentSliceFragment } from "../../types/graphql";
import { FAQPage } from "schema-dts";
import { helmetJsonLdProp } from "react-schemaorg";

interface IFAQMetadataProps {
  nestedContent?: NestedContentSliceFragment["items"];
}

const FAQMetadata = (props: IFAQMetadataProps) => {
  const renderMetadata = () => {
    const nestedContent = props.nestedContent;

    if (!nestedContent || nestedContent.length < 1) {
      return <></>;
    }

    return (
      <Helmet
        script={[
          helmetJsonLdProp<FAQPage>({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: nestedContent.map((entry) => {
              return {
                "@type": "Question",
                name: `${entry?.header}`,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: `${entry?.content?.html}`,
                },
              };
            }),
          }),
        ]}
      />
    );
  };

  return <>{renderMetadata()}</>;
};

export default FAQMetadata;
